/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { ProgressIndicator } from 'sarsaparilla';

export default function Progress({ activeStep, steps }) {
    return (
        <div className="ia-progress">
            <div className="ia-progress-container">
                <ProgressIndicator activeStep={activeStep} steps={steps} />
            </div>
        </div>
    );
}

Progress.propTypes = {
    activeStep: PropTypes.number,
    steps: PropTypes.arrayOf(PropTypes.string).isRequired,
};
